// Monthly dummy data for all MIS components

export const dummyData = {
  // Data keyed by month strings
  "Jan 2026": {
    // Financial Summary data
    financial: {
      overdueAmount: "465.00L",
      projectedCollection: "93.00L",
      promiseToPay: "35.00L",
    },
    // Alerts data
    alerts: [
      {
        title: "Overdue Amount",
        trend: "up",
        percent: "32.9%",
        description: "Overdue amount is 32.9% above historical average",
      },
      {
        title: "Projected Collection",
        trend: "down",
        percent: "38.0%",
        description: "Projected collection is 38.0% below historical average",
      },
    ],

    stats: {
      totalCases: 200,
      amountDisbursed: "6.00Cr",
      loansWithPF: 165,
      loansWithoutPF: 35,
    },
    // Financial breakdown
    breakdown: {
      totalDisbursed: "6.00Cr",
      principalRepaid: "3.20Cr",
      interestCollected: "1.80Cr",
      outstanding: "1.00Cr",
    },
    // EMI data
    emis: [
      {
        emi: 1,
        cases: 95,
        month: "Jan",
        amount: "45.00L",
        breakdown: ["Principal: 35L", "Interest: 10L"],
        pct: "52.1%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 2,
        cases: 92,
        month: "Feb",
        amount: "43.50L",
        breakdown: ["Principal: 34L", "Interest: 9.5L"],
        pct: "50.4%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 3,
        cases: 90,
        month: "Mar",
        amount: "42.00L",
        breakdown: ["Principal: 33L", "Interest: 9L"],
        pct: "48.7%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 4,
        cases: 88,
        month: "Apr",
        amount: "40.50L",
        breakdown: ["Principal: 32L", "Interest: 8.5L"],
        pct: "46.9%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
      {
        emi: 5,
        cases: 85,
        month: "May",
        amount: "39.00L",
        breakdown: ["Principal: 31L", "Interest: 8L"],
        pct: "45.2%",
        accentColor: "#06B6D4",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 6,
        cases: 82,
        month: "Jun",
        amount: "37.50L",
        breakdown: ["Principal: 30L", "Interest: 7.5L"],
        pct: "43.5%",
        accentColor: "#8B5CF6",
        badgeBg: "#F5F3FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 7,
        cases: 80,
        month: "July",
        amount: "36.00L",
        breakdown: ["Principal: 29L", "Interest: 7L"],
        pct: "41.8%",
        accentColor: "#EC4899",
        badgeBg: "#FDF2F8",
        badgeColor: "#DB2777",
      },
      {
        emi: 8,
        cases: 78,
        month: "Aug",
        amount: "34.50L",
        breakdown: ["Principal: 28L", "Interest: 6.5L"],
        pct: "40.1%",
        accentColor: "#14B8A6",
        badgeBg: "#F0FDFA",
        badgeColor: "#0D9488",
      },
      {
        emi: 9,
        cases: 75,
        month: "Sept",
        amount: "33.00L",
        breakdown: ["Principal: 27L", "Interest: 6L"],
        pct: "38.4%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 10,
        cases: 72,
        month: "Oct",
        amount: "31.50L",
        breakdown: ["Principal: 26L", "Interest: 5.5L"],
        pct: "36.7%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 11,
        cases: 70,
        month: "Nov",
        amount: "30.00L",
        breakdown: ["Principal: 25L", "Interest: 5L"],
        pct: "35.0%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 12,
        cases: 68,
        month: "Dec",
        amount: "28.50L",
        breakdown: ["Principal: 24L", "Interest: 4.5L"],
        pct: "33.3%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
    ],
    // Collection Summary data
    collection: {
      totalDue: "5.20Cr",
      totalCollected: "4.42Cr",
      pending: "0.60Cr",
      defaulted: "0.18Cr",
      collectionRate: "85.0%",
      collectionGap: "0.78Cr",
    },
  },

  "Feb 2026": {
    financial: {
      overdueAmount: "480.00L",
      projectedCollection: "98.00L",
      promiseToPay: "38.00L",
    },
    alerts: [
      {
        title: "Overdue Amount",
        trend: "up",
        percent: "35.2%",
        description: "Overdue amount is 35.2% above historical average",
      },
      {
        title: "Projected Collection",
        trend: "down",
        percent: "42.1%",
        description: "Projected collection is 42.1% below historical average",
      },
    ],
    stats: {
      totalCases: 210,
      amountDisbursed: "6.20Cr",
      loansWithPF: 175,
      loansWithoutPF: 35,
    },
    breakdown: {
      totalDisbursed: "6.20Cr",
      principalRepaid: "3.40Cr",
      interestCollected: "1.90Cr",
      outstanding: "0.90Cr",
    },
    emis: [
      {
        emi: 1,
        cases: 100,
        month: "Feb",
        amount: "46.00L",
        breakdown: ["Principal: 36L", "Interest: 10L"],
        pct: "51.5%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 2,
        cases: 97,
        month: "Mar",
        amount: "44.50L",
        breakdown: ["Principal: 35L", "Interest: 9.5L"],
        pct: "49.8%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 3,
        cases: 95,
        month: "Apr",
        amount: "43.00L",
        breakdown: ["Principal: 34L", "Interest: 9L"],
        pct: "48.1%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 4,
        cases: 92,
        month: "May",
        amount: "41.50L",
        breakdown: ["Principal: 33L", "Interest: 8.5L"],
        pct: "46.3%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
      {
        emi: 5,
        cases: 90,
        month: "Jun",
        amount: "40.00L",
        breakdown: ["Principal: 32L", "Interest: 8L"],
        pct: "44.6%",
        accentColor: "#06B6D4",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 6,
        cases: 87,
        month: "July",
        amount: "38.50L",
        breakdown: ["Principal: 31L", "Interest: 7.5L"],
        pct: "42.9%",
        accentColor: "#8B5CF6",
        badgeBg: "#F5F3FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 7,
        cases: 85,
        month: "Aug",
        amount: "37.00L",
        breakdown: ["Principal: 30L", "Interest: 7L"],
        pct: "41.2%",
        accentColor: "#EC4899",
        badgeBg: "#FDF2F8",
        badgeColor: "#DB2777",
      },
      {
        emi: 8,
        cases: 82,
        month: "Sept",
        amount: "35.50L",
        breakdown: ["Principal: 29L", "Interest: 6.5L"],
        pct: "39.5%",
        accentColor: "#14B8A6",
        badgeBg: "#F0FDFA",
        badgeColor: "#0D9488",
      },
      {
        emi: 9,
        cases: 80,
        month: "Oct",
        amount: "34.00L",
        breakdown: ["Principal: 28L", "Interest: 6L"],
        pct: "37.8%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 10,
        cases: 77,
        month: "Nov",
        amount: "32.50L",
        breakdown: ["Principal: 27L", "Interest: 5.5L"],
        pct: "36.1%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 11,
        cases: 75,
        month: "Dec",
        amount: "31.00L",
        breakdown: ["Principal: 26L", "Interest: 5L"],
        pct: "34.4%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 12,
        cases: 72,
        month: "Jan",
        amount: "29.50L",
        breakdown: ["Principal: 25L", "Interest: 4.5L"],
        pct: "32.7%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
    ],
    collection: {
      totalDue: "5.35Cr",
      totalCollected: "4.58Cr",
      pending: "0.65Cr",
      defaulted: "0.12Cr",
      collectionRate: "85.6%",
      collectionGap: "0.77Cr",
    },
  },

  "Mar 2026": {
    financial: {
      overdueAmount: "445.00L",
      projectedCollection: "88.00L",
      promiseToPay: "32.00L",
    },
    alerts: [
      {
        title: "Overdue Amount",
        trend: "up",
        percent: "28.5%",
        description: "Overdue amount is 28.5% above historical average",
      },
      {
        title: "Projected Collection",
        trend: "down",
        percent: "35.7%",
        description: "Projected collection is 35.7% below historical average",
      },
    ],
    stats: {
      totalCases: 195,
      amountDisbursed: "5.80Cr",
      loansWithPF: 160,
      loansWithoutPF: 35,
    },
    breakdown: {
      totalDisbursed: "5.80Cr",
      principalRepaid: "3.10Cr",
      interestCollected: "1.70Cr",
      outstanding: "1.00Cr",
    },
    emis: [
      {
        emi: 1,
        cases: 92,
        month: "Mar",
        amount: "44.00L",
        breakdown: ["Principal: 34L", "Interest: 10L"],
        pct: "50.8%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 2,
        cases: 89,
        month: "Apr",
        amount: "42.50L",
        breakdown: ["Principal: 33L", "Interest: 9.5L"],
        pct: "49.1%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 3,
        cases: 87,
        month: "May",
        amount: "41.00L",
        breakdown: ["Principal: 32L", "Interest: 9L"],
        pct: "47.4%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 4,
        cases: 85,
        month: "Jun",
        amount: "39.50L",
        breakdown: ["Principal: 31L", "Interest: 8.5L"],
        pct: "45.6%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
      {
        emi: 5,
        cases: 82,
        month: "July",
        amount: "38.00L",
        breakdown: ["Principal: 30L", "Interest: 8L"],
        pct: "43.9%",
        accentColor: "#06B6D4",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 6,
        cases: 80,
        month: "Aug",
        amount: "36.50L",
        breakdown: ["Principal: 29L", "Interest: 7.5L"],
        pct: "42.2%",
        accentColor: "#8B5CF6",
        badgeBg: "#F5F3FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 7,
        cases: 78,
        month: "Sept",
        amount: "35.00L",
        breakdown: ["Principal: 28L", "Interest: 7L"],
        pct: "40.5%",
        accentColor: "#EC4899",
        badgeBg: "#FDF2F8",
        badgeColor: "#DB2777",
      },
      {
        emi: 8,
        cases: 75,
        month: "Oct",
        amount: "33.50L",
        breakdown: ["Principal: 27L", "Interest: 6.5L"],
        pct: "38.8%",
        accentColor: "#14B8A6",
        badgeBg: "#F0FDFA",
        badgeColor: "#0D9488",
      },
      {
        emi: 9,
        cases: 73,
        month: "Nov",
        amount: "32.00L",
        breakdown: ["Principal: 26L", "Interest: 6L"],
        pct: "37.1%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 10,
        cases: 70,
        month: "Dec",
        amount: "30.50L",
        breakdown: ["Principal: 25L", "Interest: 5.5L"],
        pct: "35.4%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 11,
        cases: 68,
        month: "Jan",
        amount: "29.00L",
        breakdown: ["Principal: 24L", "Interest: 5L"],
        pct: "33.7%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 12,
        cases: 65,
        month: "Feb",
        amount: "27.50L",
        breakdown: ["Principal: 23L", "Interest: 4.5L"],
        pct: "32.0%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
    ],
    collection: {
      totalDue: "5.05Cr",
      totalCollected: "4.35Cr",
      pending: "0.55Cr",
      defaulted: "0.15Cr",
      collectionRate: "86.1%",
      collectionGap: "0.70Cr",
    },
  },

  "Apr 2026": {
    financial: {
      overdueAmount: "425.00L",
      projectedCollection: "85.00L",
      promiseToPay: "30.00L",
    },
    alerts: [
      {
        title: "Overdue Amount",
        trend: "down",
        percent: "25.3%",
        description: "Overdue amount is 25.3% above historical average",
      },
      {
        title: "Projected Collection",
        trend: "down",
        percent: "32.4%",
        description: "Projected collection is 32.4% below historical average",
      },
    ],
    stats: {
      totalCases: 188,
      amountDisbursed: "5.60Cr",
      loansWithPF: 155,
      loansWithoutPF: 33,
    },
    breakdown: {
      totalDisbursed: "5.60Cr",
      principalRepaid: "3.00Cr",
      interestCollected: "1.60Cr",
      outstanding: "1.00Cr",
    },
    emis: [
      {
        emi: 1,
        cases: 88,
        month: "Apr",
        amount: "42.00L",
        breakdown: ["Principal: 32L", "Interest: 10L"],
        pct: "49.5%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 2,
        cases: 85,
        month: "May",
        amount: "40.50L",
        breakdown: ["Principal: 31L", "Interest: 9.5L"],
        pct: "47.8%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 3,
        cases: 83,
        month: "Jun",
        amount: "39.00L",
        breakdown: ["Principal: 30L", "Interest: 9L"],
        pct: "46.1%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 4,
        cases: 80,
        month: "July",
        amount: "37.50L",
        breakdown: ["Principal: 29L", "Interest: 8.5L"],
        pct: "44.3%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
      {
        emi: 5,
        cases: 78,
        month: "Aug",
        amount: "36.00L",
        breakdown: ["Principal: 28L", "Interest: 8L"],
        pct: "42.6%",
        accentColor: "#06B6D4",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 6,
        cases: 75,
        month: "Sept",
        amount: "34.50L",
        breakdown: ["Principal: 27L", "Interest: 7.5L"],
        pct: "40.9%",
        accentColor: "#8B5CF6",
        badgeBg: "#F5F3FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 7,
        cases: 73,
        month: "Oct",
        amount: "33.00L",
        breakdown: ["Principal: 26L", "Interest: 7L"],
        pct: "39.2%",
        accentColor: "#EC4899",
        badgeBg: "#FDF2F8",
        badgeColor: "#DB2777",
      },
      {
        emi: 8,
        cases: 70,
        month: "Nov",
        amount: "31.50L",
        breakdown: ["Principal: 25L", "Interest: 6.5L"],
        pct: "37.5%",
        accentColor: "#14B8A6",
        badgeBg: "#F0FDFA",
        badgeColor: "#0D9488",
      },
      {
        emi: 9,
        cases: 68,
        month: "Dec",
        amount: "30.00L",
        breakdown: ["Principal: 24L", "Interest: 6L"],
        pct: "35.8%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 10,
        cases: 65,
        month: "Jan",
        amount: "28.50L",
        breakdown: ["Principal: 23L", "Interest: 5.5L"],
        pct: "34.1%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 11,
        cases: 63,
        month: "Feb",
        amount: "27.00L",
        breakdown: ["Principal: 22L", "Interest: 5L"],
        pct: "32.4%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 12,
        cases: 60,
        month: "Mar",
        amount: "25.50L",
        breakdown: ["Principal: 21L", "Interest: 4.5L"],
        pct: "30.7%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
    ],
    collection: {
      totalDue: "4.90Cr",
      totalCollected: "4.25Cr",
      pending: "0.50Cr",
      defaulted: "0.15Cr",
      collectionRate: "86.7%",
      collectionGap: "0.65Cr",
    },
  },

  "May 2026": {
    financial: {
      overdueAmount: "410.00L",
      projectedCollection: "82.00L",
      promiseToPay: "28.00L",
    },
    alerts: [
      {
        title: "Overdue Amount",
        trend: "down",
        percent: "22.1%",
        description: "Overdue amount is 22.1% above historical average",
      },
      {
        title: "Projected Collection",
        trend: "down",
        percent: "29.1%",
        description: "Projected collection is 29.1% below historical average",
      },
    ],
    stats: {
      totalCases: 182,
      amountDisbursed: "5.40Cr",
      loansWithPF: 150,
      loansWithoutPF: 32,
    },
    breakdown: {
      totalDisbursed: "5.40Cr",
      principalRepaid: "2.90Cr",
      interestCollected: "1.50Cr",
      outstanding: "1.00Cr",
    },
    emis: [
      {
        emi: 1,
        cases: 85,
        month: "May",
        amount: "40.00L",
        breakdown: ["Principal: 30L", "Interest: 10L"],
        pct: "48.2%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 2,
        cases: 82,
        month: "Jun",
        amount: "38.50L",
        breakdown: ["Principal: 29L", "Interest: 9.5L"],
        pct: "46.5%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 3,
        cases: 80,
        month: "July",
        amount: "37.00L",
        breakdown: ["Principal: 28L", "Interest: 9L"],
        pct: "44.8%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 4,
        cases: 77,
        month: "Aug",
        amount: "35.50L",
        breakdown: ["Principal: 27L", "Interest: 8.5L"],
        pct: "43.0%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
      {
        emi: 5,
        cases: 75,
        month: "Sept",
        amount: "34.00L",
        breakdown: ["Principal: 26L", "Interest: 8L"],
        pct: "41.3%",
        accentColor: "#06B6D4",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 6,
        cases: 72,
        month: "Oct",
        amount: "32.50L",
        breakdown: ["Principal: 25L", "Interest: 7.5L"],
        pct: "39.6%",
        accentColor: "#8B5CF6",
        badgeBg: "#F5F3FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 7,
        cases: 70,
        month: "Nov",
        amount: "31.00L",
        breakdown: ["Principal: 24L", "Interest: 7L"],
        pct: "37.9%",
        accentColor: "#EC4899",
        badgeBg: "#FDF2F8",
        badgeColor: "#DB2777",
      },
      {
        emi: 8,
        cases: 67,
        month: "Dec",
        amount: "29.50L",
        breakdown: ["Principal: 23L", "Interest: 6.5L"],
        pct: "36.2%",
        accentColor: "#14B8A6",
        badgeBg: "#F0FDFA",
        badgeColor: "#0D9488",
      },
      {
        emi: 9,
        cases: 65,
        month: "Jan",
        amount: "28.00L",
        breakdown: ["Principal: 22L", "Interest: 6L"],
        pct: "34.5%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 10,
        cases: 62,
        month: "Feb",
        amount: "26.50L",
        breakdown: ["Principal: 21L", "Interest: 5.5L"],
        pct: "32.8%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 11,
        cases: 60,
        month: "Mar",
        amount: "25.00L",
        breakdown: ["Principal: 20L", "Interest: 5L"],
        pct: "31.1%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 12,
        cases: 58,
        month: "Apr",
        amount: "23.50L",
        breakdown: ["Principal: 19L", "Interest: 4.5L"],
        pct: "29.4%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
    ],
    collection: {
      totalDue: "4.75Cr",
      totalCollected: "4.15Cr",
      pending: "0.45Cr",
      defaulted: "0.15Cr",
      collectionRate: "87.4%",
      collectionGap: "0.60Cr",
    },
  },

  "Jun 2026": {
    financial: {
      overdueAmount: "395.00L",
      projectedCollection: "79.00L",
      promiseToPay: "26.00L",
    },
    alerts: [
      {
        title: "Overdue Amount",
        trend: "down",
        percent: "18.9%",
        description: "Overdue amount is 18.9% above historical average",
      },
      {
        title: "Projected Collection",
        trend: "down",
        percent: "25.8%",
        description: "Projected collection is 25.8% below historical average",
      },
    ],
    stats: {
      totalCases: 175,
      amountDisbursed: "5.20Cr",
      loansWithPF: 145,
      loansWithoutPF: 30,
    },
    breakdown: {
      totalDisbursed: "5.20Cr",
      principalRepaid: "2.80Cr",
      interestCollected: "1.40Cr",
      outstanding: "1.00Cr",
    },
    emis: [
      {
        emi: 1,
        cases: 82,
        month: "Jun",
        amount: "38.00L",
        breakdown: ["Principal: 28L", "Interest: 10L"],
        pct: "46.9%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 2,
        cases: 79,
        month: "July",
        amount: "36.50L",
        breakdown: ["Principal: 27L", "Interest: 9.5L"],
        pct: "45.2%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 3,
        cases: 77,
        month: "Aug",
        amount: "35.00L",
        breakdown: ["Principal: 26L", "Interest: 9L"],
        pct: "43.5%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 4,
        cases: 74,
        month: "Sept",
        amount: "33.50L",
        breakdown: ["Principal: 25L", "Interest: 8.5L"],
        pct: "41.7%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
      {
        emi: 5,
        cases: 72,
        month: "Oct",
        amount: "32.00L",
        breakdown: ["Principal: 24L", "Interest: 8L"],
        pct: "40.0%",
        accentColor: "#06B6D4",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 6,
        cases: 69,
        month: "Nov",
        amount: "30.50L",
        breakdown: ["Principal: 23L", "Interest: 7.5L"],
        pct: "38.3%",
        accentColor: "#8B5CF6",
        badgeBg: "#F5F3FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 7,
        cases: 67,
        month: "Dec",
        amount: "29.00L",
        breakdown: ["Principal: 22L", "Interest: 7L"],
        pct: "36.6%",
        accentColor: "#EC4899",
        badgeBg: "#FDF2F8",
        badgeColor: "#DB2777",
      },
      {
        emi: 8,
        cases: 64,
        month: "Jan",
        amount: "27.50L",
        breakdown: ["Principal: 21L", "Interest: 6.5L"],
        pct: "34.9%",
        accentColor: "#14B8A6",
        badgeBg: "#F0FDFA",
        badgeColor: "#0D9488",
      },
      {
        emi: 9,
        cases: 62,
        month: "Feb",
        amount: "26.00L",
        breakdown: ["Principal: 20L", "Interest: 6L"],
        pct: "33.2%",
        accentColor: "#7C3AED",
        badgeBg: "#FAF5FF",
        badgeColor: "#7C3AED",
      },
      {
        emi: 10,
        cases: 59,
        month: "Mar",
        amount: "24.50L",
        breakdown: ["Principal: 19L", "Interest: 5.5L"],
        pct: "31.5%",
        accentColor: "#0891B2",
        badgeBg: "#ECFEFF",
        badgeColor: "#0891B2",
      },
      {
        emi: 11,
        cases: 57,
        month: "Apr",
        amount: "23.00L",
        breakdown: ["Principal: 18L", "Interest: 5L"],
        pct: "29.8%",
        accentColor: "#F97316",
        badgeBg: "#FFF7ED",
        badgeColor: "#EA580C",
      },
      {
        emi: 12,
        cases: 55,
        month: "May",
        amount: "21.50L",
        breakdown: ["Principal: 17L", "Interest: 4.5L"],
        pct: "28.1%",
        accentColor: "#84CC16",
        badgeBg: "#F7FEE7",
        badgeColor: "#65A30D",
      },
    ],
    collection: {
      totalDue: "4.60Cr",
      totalCollected: "4.05Cr",
      pending: "0.40Cr",
      defaulted: "0.15Cr",
      collectionRate: "88.0%",
      collectionGap: "0.55Cr",
    },
  },
};

export const funnelData = {
  "Jan 2026": {
    stages: [
      {
        label: "Total Due",
        value: "440.00L",
        percent: 100.0,
        color: "#3B82F6",
        barWidth: "100%",
        isCircle: false,
      },
      {
        label: "Collection Attempted",
        value: "420.00L",
        percent: 95.5,
        color: "#8B5CF6",
        barWidth: "95.5%",
        isCircle: false,
      },
      {
        label: "Successfully Collected",
        value: "352.00L",
        percent: 80.0,
        color: "#10B981",
        barWidth: "80%",
        isCircle: false,
      },
      {
        label: "Pending Collection",
        value: "66.00L",
        percent: 15.0,
        color: "#F59E0B",
        barWidth: "15%",
        isCircle: false,
      },
      {
        label: "Defaulted",
        value: "22.00L",
        percent: 5.0,
        color: "#EF4444",
        barWidth: "5%",
        isCircle: true,
      },
    ],
    dropoffRows: [
      {
        label: "Due -> Attempted",
        sub: "Not attempted",
        value: "20.00L",
        drop: "4.5% drop",
        valueColor: "#E7000B",
        dropColor: "#4A5565",
        bg: "#FEF2F2",
      },
      {
        label: "Attempted -> Collected",
        sub: "Failed attempts",
        value: "68.00L",
        drop: "16.2% drop",
        valueColor: "#D08700",
        dropColor: "#4A5565",
        bg: "#FEFCE8",
      },
      {
        label: "Success Rate",
        sub: "Collected from attempted",
        value: "83.8%",
        drop: "Conversion efficiency",
        valueColor: "#00A63E",
        dropColor: "#4A5565",
        bg: "#F0FDF4",
      },
    ],
  },
  "Feb 2026": {
    stages: [
      {
        label: "Total Due",
        value: "455.00L",
        percent: 100.0,
        color: "#3B82F6",
        barWidth: "100%",
        isCircle: false,
      },
      {
        label: "Collection Attempted",
        value: "435.00L",
        percent: 95.6,
        color: "#8B5CF6",
        barWidth: "95.6%",
        isCircle: false,
      },
      {
        label: "Successfully Collected",
        value: "368.00L",
        percent: 80.9,
        color: "#10B981",
        barWidth: "80.9%",
        isCircle: false,
      },
      {
        label: "Pending Collection",
        value: "67.00L",
        percent: 14.7,
        color: "#F59E0B",
        barWidth: "14.7%",
        isCircle: false,
      },
      {
        label: "Defaulted",
        value: "20.00L",
        percent: 4.4,
        color: "#EF4444",
        barWidth: "4.4%",
        isCircle: true,
      },
    ],
    dropoffRows: [
      {
        label: "Due -> Attempted",
        sub: "Not attempted",
        value: "20.00L",
        drop: "4.4% drop",
        valueColor: "#E7000B",
        dropColor: "#4A5565",
        bg: "#FEF2F2",
      },
      {
        label: "Attempted -> Collected",
        sub: "Failed attempts",
        value: "67.00L",
        drop: "15.4% drop",
        valueColor: "#D08700",
        dropColor: "#4A5565",
        bg: "#FEFCE8",
      },
      {
        label: "Success Rate",
        sub: "Collected from attempted",
        value: "84.6%",
        drop: "Conversion efficiency",
        valueColor: "#00A63E",
        dropColor: "#4A5565",
        bg: "#F0FDF4",
      },
    ],
  },
  "Mar 2026": {
    stages: [
      {
        label: "Total Due",
        value: "425.00L",
        percent: 100.0,
        color: "#3B82F6",
        barWidth: "100%",
        isCircle: false,
      },
      {
        label: "Collection Attempted",
        value: "408.00L",
        percent: 96.0,
        color: "#8B5CF6",
        barWidth: "96.0%",
        isCircle: false,
      },
      {
        label: "Successfully Collected",
        value: "344.00L",
        percent: 80.9,
        color: "#10B981",
        barWidth: "80.9%",
        isCircle: false,
      },
      {
        label: "Pending Collection",
        value: "64.00L",
        percent: 15.1,
        color: "#F59E0B",
        barWidth: "15.1%",
        isCircle: false,
      },
      {
        label: "Defaulted",
        value: "17.00L",
        percent: 4.0,
        color: "#EF4444",
        barWidth: "4.0%",
        isCircle: true,
      },
    ],
    dropoffRows: [
      {
        label: "Due -> Attempted",
        sub: "Not attempted",
        value: "17.00L",
        drop: "4.0% drop",
        valueColor: "#E7000B",
        dropColor: "#4A5565",
        bg: "#FEF2F2",
      },
      {
        label: "Attempted -> Collected",
        sub: "Failed attempts",
        value: "64.00L",
        drop: "15.7% drop",
        valueColor: "#D08700",
        dropColor: "#4A5565",
        bg: "#FEFCE8",
      },
      {
        label: "Success Rate",
        sub: "Collected from attempted",
        value: "84.3%",
        drop: "Conversion efficiency",
        valueColor: "#00A63E",
        dropColor: "#4A5565",
        bg: "#F0FDF4",
      },
    ],
  },
  "Apr 2026": {
    stages: [
      {
        label: "Total Due",
        value: "410.00L",
        percent: 100.0,
        color: "#3B82F6",
        barWidth: "100%",
        isCircle: false,
      },
      {
        label: "Collection Attempted",
        value: "395.00L",
        percent: 96.3,
        color: "#8B5CF6",
        barWidth: "96.3%",
        isCircle: false,
      },
      {
        label: "Successfully Collected",
        value: "335.00L",
        percent: 81.7,
        color: "#10B981",
        barWidth: "81.7%",
        isCircle: false,
      },
      {
        label: "Pending Collection",
        value: "60.00L",
        percent: 14.6,
        color: "#F59E0B",
        barWidth: "14.6%",
        isCircle: false,
      },
      {
        label: "Defaulted",
        value: "15.00L",
        percent: 3.7,
        color: "#EF4444",
        barWidth: "3.7%",
        isCircle: true,
      },
    ],
    dropoffRows: [
      {
        label: "Due -> Attempted",
        sub: "Not attempted",
        value: "15.00L",
        drop: "3.7% drop",
        valueColor: "#E7000B",
        dropColor: "#4A5565",
        bg: "#FEF2F2",
      },
      {
        label: "Attempted -> Collected",
        sub: "Failed attempts",
        value: "60.00L",
        drop: "15.2% drop",
        valueColor: "#D08700",
        dropColor: "#4A5565",
        bg: "#FEFCE8",
      },
      {
        label: "Success Rate",
        sub: "Collected from attempted",
        value: "84.8%",
        drop: "Conversion efficiency",
        valueColor: "#00A63E",
        dropColor: "#4A5565",
        bg: "#F0FDF4",
      },
    ],
  },
  "May 2026": {
    stages: [
      {
        label: "Total Due",
        value: "395.00L",
        percent: 100.0,
        color: "#3B82F6",
        barWidth: "100%",
        isCircle: false,
      },
      {
        label: "Collection Attempted",
        value: "382.00L",
        percent: 96.7,
        color: "#8B5CF6",
        barWidth: "96.7%",
        isCircle: false,
      },
      {
        label: "Successfully Collected",
        value: "326.00L",
        percent: 82.5,
        color: "#10B981",
        barWidth: "82.5%",
        isCircle: false,
      },
      {
        label: "Pending Collection",
        value: "56.00L",
        percent: 14.2,
        color: "#F59E0B",
        barWidth: "14.2%",
        isCircle: false,
      },
      {
        label: "Defaulted",
        value: "13.00L",
        percent: 3.3,
        color: "#EF4444",
        barWidth: "3.3%",
        isCircle: true,
      },
    ],
    dropoffRows: [
      {
        label: "Due -> Attempted",
        sub: "Not attempted",
        value: "13.00L",
        drop: "3.3% drop",
        valueColor: "#E7000B",
        dropColor: "#4A5565",
        bg: "#FEF2F2",
      },
      {
        label: "Attempted -> Collected",
        sub: "Failed attempts",
        value: "56.00L",
        drop: "14.7% drop",
        valueColor: "#D08700",
        dropColor: "#4A5565",
        bg: "#FEFCE8",
      },
      {
        label: "Success Rate",
        sub: "Collected from attempted",
        value: "85.3%",
        drop: "Conversion efficiency",
        valueColor: "#00A63E",
        dropColor: "#4A5565",
        bg: "#F0FDF4",
      },
    ],
  },
  "Jun 2026": {
    stages: [
      {
        label: "Total Due",
        value: "380.00L",
        percent: 100.0,
        color: "#3B82F6",
        barWidth: "100%",
        isCircle: false,
      },
      {
        label: "Collection Attempted",
        value: "369.00L",
        percent: 97.1,
        color: "#8B5CF6",
        barWidth: "97.1%",
        isCircle: false,
      },
      {
        label: "Successfully Collected",
        value: "317.00L",
        percent: 83.4,
        color: "#10B981",
        barWidth: "83.4%",
        isCircle: false,
      },
      {
        label: "Pending Collection",
        value: "52.00L",
        percent: 13.7,
        color: "#F59E0B",
        barWidth: "13.7%",
        isCircle: false,
      },
      {
        label: "Defaulted",
        value: "11.00L",
        percent: 2.9,
        color: "#EF4444",
        barWidth: "2.9%",
        isCircle: true,
      },
    ],
    dropoffRows: [
      {
        label: "Due -> Attempted",
        sub: "Not attempted",
        value: "11.00L",
        drop: "2.9% drop",
        valueColor: "#E7000B",
        dropColor: "#4A5565",
        bg: "#FEF2F2",
      },
      {
        label: "Attempted -> Collected",
        sub: "Failed attempts",
        value: "52.00L",
        drop: "14.1% drop",
        valueColor: "#D08700",
        dropColor: "#4A5565",
        bg: "#FEFCE8",
      },
      {
        label: "Success Rate",
        sub: "Collected from attempted",
        value: "85.9%",
        drop: "Conversion efficiency",
        valueColor: "#00A63E",
        dropColor: "#4A5565",
        bg: "#F0FDF4",
      },
    ],
  },
};

// Helper function to get data for a specific month
export const getDataForMonth = (month) => {
  return dummyData[month] || dummyData["Apr 2026"]; // Default to Apr 2026 if month not found
};

// Helper function to get funnel data for a specific month
export const getFunnelDataForMonth = (month) => {
  return funnelData[month] || funnelData["Apr 2026"]; // Default to Apr 2026 if month not found
};
